import { Injectable } from '@angular/core'
import { isFunction } from 'lodash'

import { IAuthorization } from './i-authorization.service'
import { AuthorizationConfig } from './authorization.config'
import { User } from 'models'

@Injectable()
export class Authorization extends IAuthorization {
  private policies: Object = {}

  constructor(private config: AuthorizationConfig) {
    super()

    this.policies = config.policies
  }

  allowed(user: User, scope: string, action: string, targetObject?: any): boolean {
    if(!user) {
      return false
    }
    else if(!this.policies[scope]) {
      console.error(`Policy scope "${ scope }" not found`)
      return false
    }
    else if(!this.policies[scope][action]) {
      console.error(`Policy "${ scope }.${ action }" not found`)
      return false
    }
    else if(!isFunction(this.policies[scope][action])) {
      console.error(`Policy "${ scope }.${ action }" is not a function`)
      return false
    } else {
      return this.policies[scope][action](user, targetObject)
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/auth/authorization.service.ts